<section class="page-section contact-section" id="contact">
  <div class="container">

    <div class="text-center mb-2">
      <h2 class="section-heading">{{'CONTACT_US' | translate}}</h2>
      <div class="section-heading-line mx-auto"></div>
    </div>

    <app-icone-divider></app-icone-divider>

    <ng-container *ngIf="shop$ | async as shop">
      <div class="row justify-content-center contact-cards">

        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <div class="contact-card">
            <div class="contact-icon-wrap"><i class="fab fa-whatsapp"></i></div>
            <div class="contact-label">{{'TELEPHONE' | translate}} / WhatsApp</div>
            <ng-container *ngIf="shopConfig.whatsappWaPath(shop.whatsapp) as wa; else noPhone">
              <a class="contact-value contact-link"
                 [href]="'https://wa.me/' + wa"
                 target="_blank" rel="noopener noreferrer">
                {{ displayWhatsapp(shop.whatsapp, wa) }}
              </a>
            </ng-container>
            <ng-template #noPhone>
              <div class="contact-value contact-value--muted">—</div>
            </ng-template>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <div class="contact-card">
            <div class="contact-icon-wrap"><i class="far fa-envelope"></i></div>
            <div class="contact-label">{{'EMAIL' | translate}}</div>
            <ng-container *ngIf="mailtoHref(shop.email) as mail; else noEmail">
              <a class="contact-value contact-link" [href]="mail">{{ shop.email.trim() }}</a>
            </ng-container>
            <ng-template #noEmail>
              <div class="contact-value contact-value--muted">—</div>
            </ng-template>
          </div>
        </div>

        <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
          <div class="contact-card">
            <div class="contact-icon-wrap"><i class="fas fa-map-marker-alt"></i></div>
            <div class="contact-label">{{'LOCALIZATION' | translate}}</div>
            <div class="contact-value pre-wrap"
                 *ngIf="shop.address && shop.address.trim(); else noAddr">{{ shop.address.trim() }}</div>
            <ng-template #noAddr>
              <div class="contact-value contact-value--muted">—</div>
            </ng-template>
          </div>
        </div>

      </div>
    </ng-container>

    <!--
      ShareThis (script en bas de index.html) ne voit que les nœuds déjà présents
      au moment de son init. Hors *ngIf async, sinon le widget ne s’affiche pas.
    -->
    <div class="row justify-content-center mt-3">
      <div class="col-lg-8 col-md-10">
        <div class="contact-card contact-share">
          <div class="sharethis-inline-share-buttons"></div>
        </div>
      </div>
    </div>
  </div>
</section>
